module.exports = __webpack_public_path__ + "img/list-bg1.848fcd17.png";